'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = function () {
  var stats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _stats$fact_node_ext = stats.fact_node_ext,
      fact_node_ext = _stats$fact_node_ext === undefined ? '' : _stats$fact_node_ext,
      ckId = stats.ckId,
      params = (0, _objectWithoutProperties3.default)(stats, ['fact_node_ext', 'ckId']);

  return (0, _extends3.default)({
    fact_node_ext: fact_node_ext || ckId || ''
  }, params);
};